import {SocialInterface} from "../intefraces/social.interface";

export class SocialModel implements SocialInterface {
    site_url: string;
}
